
import Button from '../../../components/base/Button';
import { Link } from 'react-router-dom';

export default function ServicesCTA() {
  return (
    <section className="py-20 bg-blue-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            建物のことなら、まずはご相談ください
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed">
            どんな小さなお悩みでも、専門スタッフが丁寧にお答えいたします。<br />
            現地調査・お見積りは無料で承っております。
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">お電話でのお問い合わせ</h3>
              <p className="text-blue-100 text-sm mb-3">平日 9:00-18:00</p>
              <a href="tel:080-1154-9876（緊急）" className="text-white font-bold text-lg hover:text-blue-200 transition-colors cursor-pointer">
                080-1154-9876（緊急）（緊急）
              </a>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">メールでのお問い合わせ</h3>
              <p className="text-blue-100 text-sm mb-3">24時間受付</p>
              <a href="mailto:masuno@mkf23.com" className="text-white font-bold hover:text-blue-200 transition-colors cursor-pointer">
                masuno@mkf23.com
              </a>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">現地調査・お打ち合わせ</h3>
              <p className="text-blue-100 text-sm mb-3">要予約</p>
              <p className="text-white font-semibold">
                無料で承ります
              </p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/contact">
              <Button size="lg" className="bg-green-600 text-white hover:bg-green-700 border-2 border-green-600 shadow-lg">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-send-plane-line"></i>
                </div>
                お問い合わせフォーム
              </Button>
            </Link>
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white border-2 border-white hover:bg-white hover:text-blue-600 transition-all duration-200 cursor-pointer whitespace-nowrap rounded-lg shadow-lg"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-customer-service-line"></i>
              </div>
              AIアシスタントに相談
            </button>
          </div>
          
        </div>
      </div>
    </section>
  );
}
